import axios from "@/plugins/axios";
import moment from "moment";

let defaultRange = function(params) {
    (params["start_date"] = moment()
        .subtract(2000, "days")
        .format("YYYY-MM-DD")),
    (params["end_date"] = moment.utc().format("YYYY-MM-DD"));
    return params;
};

export default {
    setStatus(id, status) {
        return axios.httpApi.patch("firing/" + id, {
            status: status
        });
    },
    get(id) {
        return axios.httpApi.get("firing/" + id);
    },
    async getGroupByStrategy(creditor, publics, strategies, approachesTypes, gatewaysIds, date, filter) {
        if (typeof date.start === 'undefined' ||
            typeof date.end === 'undefined' ||
            date.start == '0000-00-00' ||
            date.end == '0000-00-00' ||
            !filter) {
            return false;
        }

        let url = "strategy-firing/";

        Object.entries(filter).forEach(([key, value]) => {
            if (value) {
                if (url == "strategy-firing/") url += "?" + key + "=" + value;
                else url += "&" + key + "=" + value;
            }
        });

        let params = {
            creditor_ids: creditor,
            strategy_public: publics,
            strategies_ids: strategies,
            start_date: date.start,
            approach_types: approachesTypes,
            gateway_ids: gatewaysIds,
            end_date: date.end,
            page: filter.page,
            limit: filter.limit
        };

        return await axios.httpApi.post(
            url,
            params
        );
    },
    searchStrategyNotificationHistory(params) {
        params = params ? params : {};
        return axios.httpApi.get("firing", { params });
    },
    async fetchNotificationCount(params) {
        params = params ? params : {};
        if (!params["start_date"] && !params["end_date"])
            params = await defaultRange(params);
        return axios.httpApi.get("firing/total", { params });
    },
    async fetchNotificationPieChart(params) {
        params = params ? params : {};
        if (!params["start_date"] && !params["end_date"])
            params = await defaultRange(params);
        return axios.httpApi.get("firing/type", { params });
    },
    async fetchNotificationBarChart(params) {
        params = params ? params : {};
        if (!params["start_date"] && !params["end_date"])
            params = await defaultRange(params);
        return axios.httpApi.get("firing/period", { params });
    },
    fetchNotificationMessages(firing_id) {
        return axios.httpApi.get("firing-approaches/" + firing_id);
    },
    dayByDay(firing_id) {
        return axios.httpApi.get("firing/" + firing_id + "/timeline");
    },
    getDeliveredRates(firingIds = '') {
        return axios.httpApi.get("firing/delivered-rates", { params: { ids: firingIds } });
    }
};